import React from 'react';
import { Dialog } from '@mui/material';
import { Button } from '@material-ui/core';
import useStyles from '../styles';

const G2Review = (props) => {
    const classes = useStyles();
    return (
        <Dialog
            className="test"
            maxWidth="lg"
            open={props.openG2Review}
            onClose={props.closeG2Review}
        >
            <div className={classes.g2Title}>
                Are you sure you want to{' '}
                {props.activeParams.g2Review === true ? 'disable' : 'enable'} the G2 Review Widget
                for {props.activeParams.name}?
            </div>
            <div className={classes.g2Desc}>
                The widget will {props.activeParams.g2Review === true ? 'no longer ' : ''}
                be visible on the side navigation bar of the admin panel.
            </div>
            <div className={classes.g2ButtonDiv}>
                <Button
                    className={classes.g2ButtonCancel}
                    onClick={props.closeG2Review}
                    color="primary"
                    autoFocus
                >
                    Cancel
                </Button>
                <Button
                    className={classes.g2ButtonEvent}
                    onClick={props.toggleG2Review}
                    color="primary"
                    autoFocus
                >
                    {props.activeParams.g2Review === true ? 'Disable' : 'Enable'}
                </Button>
            </div>
        </Dialog>
    );
};

export default G2Review;
